module.exports = __webpack_public_path__ + "img/H2-MonFAD@2x-100.1dfd4ef2.jpg";